/**
 * Shared unauthorized / session-expired panel for dashboard tabs.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserLock } from 'react-icons/fa';
import { useI18n } from '../../contexts/I18n';

export function isUnauthorizedError(err) {
  if (!err) return false;
  const msg = String(err);
  return msg === 'UNAUTHORIZED' || /unauthorized/i.test(msg);
}

export function toAuthErrorMessage(e) {
  if (e?.status === 401 || /unauthorized/i.test(e?.message || '')) {
    return 'UNAUTHORIZED';
  }
  return e?.message || 'Request failed';
}

export default function AuthRequiredPanel({
  title,
  hint,
  className = '',
}) {
  const navigate = useNavigate();
  const { t, lang } = useI18n();

  return (
    <div className={`dashboard-auth-required ${lang === 'ar' ? 'rtl' : ''} ${className}`.trim()}>
      <div className="dashboard-auth-required-icon" aria-hidden="true">
        <FaUserLock />
      </div>
      <h4 className="dashboard-auth-required-title">
        {title || t('dashSessionExpired') || 'Sign in to continue'}
      </h4>
      <p className="dashboard-auth-required-text">
        {hint ||
          t('dashSessionExpiredHint') ||
          'Your session ended. Sign in again to continue.'}
      </p>
      <button
        type="button"
        className="dashboard-auth-required-btn"
        onClick={() => navigate('/login', { state: { from: '/dashboard' } })}
      >
        {t('login') || 'Login'}
      </button>
    </div>
  );
}
